import { useEffect, useRef, useState } from 'react';
import ReactHowler from 'react-howler';
import { useDispatch, useSelector } from 'react-redux';
import { SET_HOMEMUSIC, SET_LOADED, SET_MOBILEPLAYER, SET_PLAYING, SET_PLAYINGFROM, SET_PLAYLOADING, SET_SHOWVIEWSONG, SET_SONG, SET_VIEWSONG, SET_VIEWSONGFROM, SET_CURRENT_TIME } from '@/redux/features/music/musicSlice';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import Lyrics from './Lyrics';
import barsAni from "../../assets/soundbars.json"
import Lottie from 'lottie-react';
import { ThreeCircles } from 'react-loader-spinner';
import { STOP_LIVESONG } from '@/redux/features/music/createSlice';
import Transcripts from './Transcripts';
import frogImg from "../../assets/greenbird.png"
import LikeButtton from './LikeButtton';
import DownloadButton from './DownloadButton';
import SongControlButton from './SongControlButton';
import ShareSongButton from './ShareSongButton';
import { Play, Pause, Volume2, VolumeX, Repeat, ChevronDown } from 'lucide-react';

const MusicPlayer = () => {

    const dispatch = useDispatch()
    const playerRef = useRef(null);
    const [wasPlayingBeforeSeek, setWasPlayingBeforeSeek] = useState(false);
    const { homeMusic, song, mobilePlayer, playing, playLoading, playingFrom, discoverSongs, userSongs, likedSongs, viewSong, showViewSong, viewSongFrom, relatedSongs, } = useSelector(state => state.music)
    const { searchSongs, genres, latestSongs } = useSelector(state => state.search)
    const { songs } = useSelector(state => state.playlists)
    const [seek, setSeek] = useState(0)
    const [duration, setDuration] = useState(0)
    const [volume, setVolume] = useState(1.0)
    // eslint-disable-next-line no-unused-vars
    const [loop, setLoop] = useState(false)
    const [mute, setMute] = useState(false)
    const [isSeeking, setIsSeeking] = useState(false)
    const location = useLocation()
    const playCountTimeout = useRef(null);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [liked, setLiked] = useState(song?.is_liked)
    const [currentTime, setCurrentTime] = useState(0);
    const animateRef = useRef()
    const loopStyleRef = useRef('all'); // 'none', 'single', 'all'
    const { songs: leaderBoardSongs, cryptoSongs: cryptoLeaderboardSongs } = useSelector(state => state.leaderboard)
    const { valentineSongs, valentineSongsFromUser } = useSelector(state => state.extradialogs)
    // Minimum swipe distance, adjust accordingly
    const minSwipeDistance = 50;
    const progressPercent = (seek / duration) * 100;
    const volumePercent = (volume / 1) * 100;

    const handleToggle = (e) => {
        e.stopPropagation()
        dispatch(SET_PLAYING(!playing));
    }

    const handleOnLoad = () => {
        dispatch(SET_LOADED(true))
        dispatch(SET_PLAYLOADING(false))
        setSeek(0)
        setCurrentTime(0)
        setDuration(playerRef.current.duration())
        handlePlayCount(song)
    };

    const handleOnPlay = () => {
        // Only proceed if we actually want the song to play
        if (loopStyleRef.current === 'none' && playerRef.current?.seek() === 0) {
            playerRef.current?.stop();
            dispatch(SET_PLAYING(false));
            return;
        }

        if (homeMusic) {
            dispatch(SET_HOMEMUSIC(false))
        }
        dispatch(SET_PLAYING(true))
        dispatch(STOP_LIVESONG())
    };

    const handleOnEnd = () => {
        handlePlayCountOnEnd(song);

        if (loopStyleRef.current === 'single') {
            if (playerRef.current) {
                dispatch(SET_PLAYING(false))
                playerRef.current.stop();
                setSeek(0);
                setCurrentTime(0);
                dispatch(SET_CURRENT_TIME(0))
                setTimeout(() => {
                    dispatch(SET_PLAYING(true))
                }, 500);
            }
        } else {
            if (playerRef.current) {
                playerRef.current.stop();
                setSeek(0);
                setCurrentTime(0);
                dispatch(SET_CURRENT_TIME(0))
                dispatch(SET_PLAYING(false));
            }

            if (loopStyleRef.current === 'all') {
                const currentSongId = song?.song_id;
                let nextSongs;
                if (playingFrom === "playlists") nextSongs = songs;
                else if (playingFrom === "discoverSongs") nextSongs = discoverSongs;
                else if (playingFrom === "userSongs") nextSongs = userSongs;
                else if (playingFrom === "likedSongs") nextSongs = likedSongs;
                else if (playingFrom === "leaderBoard") nextSongs = leaderBoardSongs;
                else if (playingFrom === "cryptoLeaderboard") nextSongs = cryptoLeaderboardSongs;
                else if (playingFrom === "relatedSongs") nextSongs = relatedSongs;
                else if (playingFrom === "genres") nextSongs = genres;
                else if (playingFrom === "trendingSongs") nextSongs = latestSongs;
                else if (playingFrom === "valentineSongs") nextSongs = valentineSongs;
                else if (playingFrom === "valentineSongsFromUser") nextSongs = valentineSongsFromUser;
                else if (playingFrom === "searchSongs") nextSongs = searchSongs;

                if (nextSongs?.length) {
                    const currentIndex = nextSongs.findIndex(s => s?.song_id === currentSongId);
                    let nextIndex = currentIndex + 1;

                    if (nextIndex >= nextSongs.length) {
                        nextIndex = 0;
                    }

                    if (nextIndex < nextSongs.length) {
                        setTimeout(() => {
                            dispatch(SET_SONG(nextSongs[nextIndex]));
                            dispatch(SET_PLAYLOADING(true));
                            dispatch(SET_PLAYING(true));
                        }, 200);
                    }
                }
            }
        }
    };

    // const handleStop = () => {
    //     playerRef.current.stop();
    //     dispatch(SET_PLAYING(false))
    //     renderSeekPos();
    // };

    const handleLoopToggle = (e) => {
        e.stopPropagation();

        // Cycle through loop styles
        if (loopStyleRef.current === 'all') {
            loopStyleRef.current = 'single';
        } else if (loopStyleRef.current === 'single') {
            loopStyleRef.current = 'none';
        } else {
            loopStyleRef.current = 'all';
        }
        setLoop(loopStyleRef.current !== 'all'); // For UI updates
    }
    const handleMuteToggle = (e) => {
        e.stopPropagation()
        setMute(!mute);
    }

    // ----------------------------Seek controls----------------------------
    const handleMouseDownSeek = (e) => {
        e.stopPropagation()
        setWasPlayingBeforeSeek(playing)
        if (playing) {
            dispatch(SET_PLAYING(false))
        }
        setIsSeeking(true)
        setCurrentTime(parseFloat(e.target.value));
        dispatch(SET_CURRENT_TIME(parseFloat(e.target.value)))
    }

    const handleMouseUpSeek = (e) => {
        e.stopPropagation();
        setIsSeeking(false);

        if (playerRef.current) {
            const newSeek = parseFloat(e.target.value);
            playerRef.current.seek(newSeek);
            setSeek(newSeek);
            setCurrentTime(newSeek);
            dispatch(SET_CURRENT_TIME(newSeek))

            // Ensure RAF is running
            if (wasPlayingBeforeSeek) {
                dispatch(SET_PLAYING(true));
            }
        }
    };

    const handleSeekingChange = (e) => {
        e.stopPropagation()
        const newSeek = parseFloat(e.target.value);
        setSeek(newSeek)
        setCurrentTime(newSeek)
        dispatch(SET_CURRENT_TIME(newSeek))
        if (isSeeking) {
            playerRef.current.seek(newSeek); // Seek as the slider moves, if needed
        }
    }

    // interval
    useEffect(() => {
        let intervalId;

        if (playing && !isSeeking && playerRef.current) {
            intervalId = setInterval(() => {
                try {
                    const currentSeek = playerRef.current.seek();
                    if (typeof currentSeek === 'number' && currentSeek !== seek) {
                        setSeek(currentSeek);
                        setCurrentTime(currentSeek);
                        dispatch(SET_CURRENT_TIME(currentSeek))
                    }
                } catch (error) {
                    console.error('Error updating seek position:', error);
                }
            }, 1000);
        }

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [playing, isSeeking, seek, dispatch]);

    // Function to format seconds to "mm:ss"
    function formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        const formattedMinutes = minutes.toString();
        const formattedSeconds = remainingSeconds.toString().padStart(2, '0');
        return `${formattedMinutes}:${formattedSeconds}`;
    }

    // -----------------------------handle Play count-------------------
    async function handlePlayCount(song) {
        const lastPlayed = sessionStorage.getItem(`lastPlayed-${song?.song_id}`);
        const now = new Date().getTime();
        const minInterval = 120000;
        const playDurationRequired = 5000;

        // Clear existing timeout to prevent multiple calls if the song changes quickly
        if (playCountTimeout.current) {
            clearTimeout(playCountTimeout.current);
        }

        // Check if the song was played more than 5 minutes ago
        if (!lastPlayed || now - parseInt(lastPlayed) > minInterval) {
            playCountTimeout.current = setTimeout(async () => {
                try {
                    await axios.post("/view", { song_id: song?.song_id });
                    sessionStorage.setItem(`lastPlayed-${song?.song_id}`, now.toString());
                } catch (error) {
                    console.error('Failed to update play count:', error);
                }
            }, playDurationRequired);
        }
    }

    // handle play count when the song ends
    async function handlePlayCountOnEnd(song) {
        const lastPlayed = sessionStorage.getItem(`lastPlayed-${song?.song_id}`);
        const now = new Date().getTime();
        const minInterval = 120000;

        if (!lastPlayed || now - parseInt(lastPlayed) > minInterval) {
            try {
                await axios.post("/view", { song_id: song?.song_id });
                sessionStorage.setItem(`lastPlayed-${song?.song_id}`, now.toString());
            } catch (error) {
                console.error('Failed to update play count:', error);
            }
        }
    }

    // -----------------------------touch controls----------------------------
    const onTouchStart = (e) => {
        setTouchStart(e.targetTouches[0].clientY);
    };

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientY);
    };

    const onTouchEnd = () => {
        if (touchStart && touchEnd) {
            const distance = touchEnd - touchStart;
            // Check if the swipe is a downward swipe and long enough
            if (distance > minSwipeDistance) {
                dispatch(SET_MOBILEPLAYER(false))
            }
        }
        // Reset values
        setTouchStart(null);
        setTouchEnd(null);
    };

    const handleMobilePlayer = () => {
        dispatch(SET_MOBILEPLAYER(true))
    }

    // // Get liked status on song change
    useEffect(() => {
        setLiked(song?.is_liked)
    }, [song])

    // play song from view that you are viewing
    const handleViewSongPlay = () => {
        dispatch(SET_PLAYING(true))
        dispatch(SET_PLAYLOADING(true))
        dispatch(SET_SONG(viewSong))
        dispatch(SET_VIEWSONG(null))
        dispatch(SET_SHOWVIEWSONG(false))
        dispatch(SET_PLAYINGFROM(viewSongFrom))
    }

    // Effect to clean up on component unmount or when the song changes
    useEffect(() => {
        return () => {
            if (playCountTimeout.current) {
                clearTimeout(playCountTimeout.current);
            }
        };
    }, [song]);

    // lottie animation ref
    useEffect(() => {
        if (playing && !playLoading) {
            animateRef.current?.play();
            animateRef.current?.setSpeed(1.8)
        } else {
            animateRef.current?.pause();
        }
    }, [playing, playLoading]);

    // add no scroll on body when mobile comopnent is active
    useEffect(() => {
        const body = document.body;
        if (mobilePlayer) {
            body.classList.add('no-scroll');
        } else {
            body.classList.remove('no-scroll');
        }

        return () => {
            body.classList.remove('no-scroll');
        };
    }, [mobilePlayer]);

    return (
        <>
            {song && <div onClick={handleMobilePlayer} className={'select-none fixed md:bottom-0 left-0 right-0 w-full bg-slate-900 dark:bg-pink-300 ' + (location.pathname === "/about" ? "bottom-0 z-[999]" : "bottom-16 z-[99]")}>
                <div className='flex border-t-green-700 dark:border-t-pink-700 border-opacity-50 border-t py-2 px-4 md:py-0 justify-between items-center gap-8 lg:gap-16 relative'>
                    <div className='absolute -z-[9]' >
                        <ReactHowler
                            src={song?.song_url}
                            playing={playing}
                            onLoad={handleOnLoad}
                            onPlay={handleOnPlay}
                            onEnd={handleOnEnd}
                            loop={false}
                            mute={mute}
                            volume={volume}
                            ref={playerRef}
                            html5={true}
                        />
                    </div>
                    <div className='flex gap-2 w-3/5 sm:w-auto md:w-1/4 overflow-hidden'>
                        {song?.image_url ?
                            <img className='w-10 md:w-16 aspect-square object-cover' src={song?.image_url} alt='song cover' />
                            : <img className='w-10 h-10 md:h-16 md:w-16 aspect-square object-cover p-1 md:p-2' src={frogImg} alt='song cover' />
                        }
                        <div className='md:hidden lg:flex flex-col justify-between w-full truncate'>
                            <p className='text-white dark:text-slate-800 truncate capitalize'>{song?.song_name}</p>
                            <span className='text-slate-400 dark:text-slate-600 text-sm truncate'>{song?.username}</span>
                        </div>
                    </div>
                    <div className='hidden md:flex flex-col flex-grow items-center py-4 gap-4 w-full'>
                        <div className='w-full max-w-xl flex items-center justify-center gap-8 lg:gap-10'>
                            <button
                                type='button'
                                className={'relative z-10 focus:outline-none ' +
                                    (loopStyleRef.current !== 'none'
                                        ? 'text-green-400 dark:text-pink-700'
                                        : 'text-white dark:text-slate-700 hover:text-green-400 dark:hover:text-pink-700')}
                                onClick={handleLoopToggle}
                            >
                                <div className="relative">
                                    <Repeat size={16} />
                                    {loopStyleRef.current === 'single' && (
                                        <span className="absolute -top-2 -right-2 text-[10px]">1</span>
                                    )}
                                    {loopStyleRef.current === 'all' && (
                                        <span className="absolute -top-2 -right-2 text-[10px]">∞</span>
                                    )}
                                </div>
                            </button>
                            <button
                                type='button'
                                className={'relative z-10 focus:outline-none ' +
                                    (mute
                                        ? "text-green-400 dark:text-pink-700"
                                        : "text-white dark:text-slate-700 hover:text-green-400 dark:hover:text-pink-700")}
                                onClick={handleMuteToggle}
                            >
                                <VolumeX size={18} />
                            </button>
                            <SongControlButton position='bigScreen' playerRef={playerRef} />
                            <LikeButtton liked={liked} setLiked={setLiked} position='bigScreen' />
                            <ShareSongButton song={song} position='bigScreen' viewSong={viewSong} showViewSong={showViewSong} />
                            <DownloadButton song={song} position='bigScreen' />
                        </div>
                        <div className='w-full max-w-xl relative border border-slate-500 dark:border-pink-700/50 rounded-full h-2'>
                            <input
                                type='range'
                                min='0'
                                max={duration ? duration.toFixed(2) : 0}
                                step='.01'
                                value={seek}
                                onClick={(e) => e.stopPropagation()}
                                onChange={handleSeekingChange}
                                onMouseDown={handleMouseDownSeek}
                                onMouseUp={handleMouseUpSeek}
                                onTouchStart={handleMouseDownSeek}
                                onTouchEnd={handleMouseUpSeek}
                                className='w-full appearance-none rounded-full h-4 cursor-pointer opacity-0 absolute -top-1 left-0 z-20 shadow-inner [&::-webkit-slider-thumb]:opacity-0 [&::-moz-range-thumb]:opacity-0'
                            />
                            <div
                                style={{ width: `${progressPercent}%` }}
                                className='h-1.5 z-10 bg-gradient-to-r to-teal-400 from-green-400 dark:to-pink-600 dark:from-pink-700 absolute top-0 rounded-full left-0'
                            ></div>
                            <span className='absolute -left-8 -top-1.5 text-xs text-slate-400 dark:text-slate-600'>{formatTime(Math.round(seek))}</span>
                            <span className='absolute -right-8 -top-1.5 text-xs text-slate-400 dark:text-slate-600'>{(duration) ? formatTime(Math.round(duration)) : 'NaN'}</span>
                        </div>
                    </div>
                    <div className='hidden md:block md:w-1/4'>
                        <div className='flex items-center justify-end gap-2 text-green-400 dark:text-pink-700'>
                            <Volume2 strokeWidth={3} size={20} onClick={(e) => e.stopPropagation()} />
                            <div className='relative border border-slate-400 dark:border-pink-700/50 rounded-full h-[5px] w-24'>
                                <input
                                    type='range'
                                    min='0'
                                    max='1'
                                    step='.05'
                                    value={volume}
                                    onChange={e => {
                                        e.stopPropagation()
                                        setVolume(parseFloat(e.target.value))
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                    className='w-full appearance-none rounded-full h-3 cursor-pointer opacity-0 border border-slate-600 dark:border-pink-700/50 absolute -top-1 left-0 z-20 shadow-inner [&::-webkit-slider-thumb]:opacity-0 [&::-moz-range-thumb]:opacity-0'
                                />
                                <div
                                    style={{ width: `${volumePercent}%` }}
                                    className='h-1 z-10 bg-gradient-to-r to-teal-400 from-green-400 dark:to-pink-600 dark:from-pink-700 absolute top-0 rounded-full left-0'
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div className='md:hidden flex items-center justify-center gap-4'>
                        <button type='button' className=' relative z-10 focus:outline-none text-green-400 fill-green-400 dark:text-pink-700 dark:fill-pink-700' onClick={handleToggle} >{!playing ? <Play className='pl-0.5 fill-green-400' size={28} /> : <Pause size={28} className='fill-green-400' />}</button>
                        <LikeButtton liked={liked} setLiked={setLiked} position='smallScreen' />
                        <ShareSongButton song={song} position='smallScreen' viewSong={viewSong} showViewSong={showViewSong} />
                    </div>
                    <div style={{ width: `${progressPercent}%` }} className={`md:hidden h-0.5 z-10 bg-gradient-to-r to-teal-400 from-green-400 dark:to-pink-600 dark:from-pink-700 absolute bottom-0 rounded-full left-0`} ></div>
                </div>
            </div>}
            <div className={'fixed top-0 left-0 flex flex-col w-full min-h-screen max-h-screen py-4 md:px-6 backdrop-blur-xl bg-slate-950 dark:bg-pink-900/10 z-[998] transition-all duration-300 ' + (mobilePlayer ? "top-[0%] overflow-y-auto" : "top-[120%]")}>
                <img className="select-none absolute opacity-25 top-0 left-0 w-full h-full object-cover -z-10 blur aspect-square" src={viewSong && showViewSong ? viewSong?.image_url : song?.image_url} alt={song?.song_name || "song cover"} />
                <div className=' px-6 md:px-0 max-w-screen-xl w-full mx-auto flex items-center gap-4 select-none justify-between mb-8 lg:mb-0' >
                    <button onClick={() => {
                        dispatch(SET_VIEWSONG(null))
                        dispatch(SET_SHOWVIEWSONG(false))
                        dispatch(SET_VIEWSONGFROM(null))
                        dispatch(SET_MOBILEPLAYER(false))
                    }} className='text-white dark:text-slate-800 p-2 flex-shrink-0' > <ChevronDown size={32} /> </button>
                    <p className='text-white dark:text-pink-950 flex-grow text-center text-lg font-potta truncate' >Sound Of Meme</p>
                    <ShareSongButton song={song} position='viewSongTop' viewSong={viewSong} showViewSong={showViewSong} />
                </div>

                <div className=' max-w-screen-xl w-full mx-auto flex flex-col md:flex-row md:justify-evenly items-center flex-grow gap-8 md:gap-16 md:pb-8' >
                    <div
                        className='max-w-md w-full px-6 md:px-0 '
                        onTouchStart={onTouchStart}
                        onTouchMove={onTouchMove}
                        onTouchEnd={onTouchEnd}>
                        <div className=' mt-8  w-full flex items-center justify-center max-w-sm lg:max-w-md mx-auto relative' >
                            <div className={`relative rounded-2xl  md:max-w-[280px] lg:max-w-[300px] w-[90%] ${playing && !playLoading && !showViewSong && " song-cover-shadow "}`} >
                                {(song?.image_url || viewSong?.image_url) ? <img src={viewSong && showViewSong ? viewSong?.image_url : song?.image_url} alt='cover' className=' aspect-square object-cover w-full rounded-2xl' /> : <img src={frogImg} alt='cover' className=' aspect-square object-cover w-full rounded-2xl p-12' />}
                                {playLoading && <div className='w-full h-full flex items-center justify-center absolute top-0 left-0 bg-slate-950/60 backdrop-blur rounded-2xl' >
                                    <ThreeCircles
                                        visible={true}
                                        height="100"
                                        width="100"
                                        color="#ffffff"
                                        ariaLabel="three-circles-loading"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                    />
                                </div>}
                            </div>
                        </div>
                        <div className={`flex items-start gap-4 ${showViewSong ? ' justify-center text-center mt-4 ' : ' justify-between mt-12 '} `}>
                            <div className=' truncate ' >
                                <p className=' truncate text-xl text-slate-200 dark:text-pink-950 font-poppins font-semibold capitalize' >{viewSong && showViewSong ? viewSong?.song_name : song?.song_name}</p>
                                <p className=' text-sm truncate text-slate-400 dark:text-pink-950 font-poppins font-medium capitalize' >{viewSong && showViewSong ? viewSong?.username : song?.username}</p>
                            </div>
                            {!showViewSong && <div className=' flex items-center gap-4 mt-1 ' >
                                <ShareSongButton song={song} position='viewSong' viewSong={viewSong} showViewSong={showViewSong} />
                                <LikeButtton liked={liked} setLiked={setLiked} position='viewSong' />
                                <DownloadButton song={song} position='viewSong' />
                            </div>}
                        </div>
                        {!showViewSong && <div className='mt-16 md:mt-20' >
                            <div className='w-full max-w-xl lg:max-w-full relative border border-slate-500 dark:border-pink-700/50 rounded-full h-2' >
                                <input
                                    type='range'
                                    min='0'
                                    max={duration ? duration.toFixed(2) : 0}
                                    step='.01'
                                    value={seek}
                                    onChange={handleSeekingChange}
                                    onMouseDown={handleMouseDownSeek}
                                    onMouseUp={handleMouseUpSeek}
                                    onTouchStart={handleMouseDownSeek}
                                    onTouchEnd={handleMouseUpSeek}
                                    className='w-full appearance-none rounded-full h-4 cursor-pointer opacity-0 absolute -top-1 left-0 z-20 shadow-inner [&::-webkit-slider-thumb]:opacity-0 [&::-moz-range-thumb]:opacity-0'
                                />
                                <div style={{ width: `${progressPercent}%` }} className={`h-1.5 z-10 bg-gradient-to-r to-teal-400 from-green-400 dark:to-pink-600 dark:from-pink-700 absolute top-0 rounded-full left-0`} ></div>
                                <span className='absolute left-0 top-3.5 text-xs text-slate-400 dark:text-black' >{formatTime(Math.round(seek))}</span>
                                <span className='absolute right-0 top-3.5 text-xs text-slate-400 dark:text-black' >{(duration) ? formatTime(Math.round(duration)) : 'NaN'}</span>
                                <div className=' w-full absolute -top-1 -translate-y-[110%] left-0 ' ><Lottie lottieRef={animateRef} animationData={barsAni} /></div>
                            </div>
                            <div className=' mt-8 w-full max-w-xl lg:max-w-full flex items-center justify-between ' >
                                <button
                                    type='button'
                                    className={'relative z-10 focus:outline-none ' +
                                        (loopStyleRef.current !== 'none' ? 'text-green-400 dark:text-pink-700' : 'text-white dark:text-pink-900 hover:text-green-400 dark:hover:text-pink-700')}
                                    onClick={handleLoopToggle}
                                >
                                    <div className="relative">
                                        <Repeat size={16} />
                                        {loopStyleRef.current === 'single' && (
                                            <span className="absolute -top-2 -right-2 text-[10px]">1</span>
                                        )}
                                        {loopStyleRef.current === 'all' && (
                                            <span className="absolute -top-2 -right-2 text-[10px]">∞</span>
                                        )}
                                    </div>
                                </button>
                                <SongControlButton position='viewSong' playerRef={playerRef} />
                                <button type='button' className={' relative z-10 focus:outline-none' + (mute ? " text-green-400 dark:text-pink-700 " : " text-white dark:text-pink-900 ")} onClick={handleMuteToggle} ><VolumeX size={20} /></button>
                            </div>
                        </div>}
                        {viewSong && showViewSong && <div className='flex items-center justify-center mt-4' >
                            <button type='button' disabled={playLoading} className=' disabled:opacity-50 relative z-10 focus:outline-none rounded-full p-2.5 bg-green-400' onClick={handleViewSongPlay} ><Play className='pl-0.5' size={32} /></button>
                        </div>}
                    </div>
                    {(song?.lyrics?.length > 5 || viewSong?.lyrics?.length > 5) && <div className='w-full md:w-auto px-1' >
                        {(viewSong || song?.transcript?.length === 0 || !song?.transcript) ?
                            <Lyrics lyrics={showViewSong ? viewSong?.lyrics : song?.lyrics} />
                            :
                            <Transcripts currentTime={currentTime?.toFixed(0)} transcript={song?.transcript} />
                        }
                    </div>}
                </div>
            </div>
        </>
    );
};

export default MusicPlayer;